import { useLayoutEffect, useState } from 'react';

const breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };

export const useBreakpoint = (breakpoint: keyof typeof breakpoints) => {
  const query = `(max-width: ${breakpoints[breakpoint] - 0.02}px)`;
  const [mobile, setMobile] = useState(() => window.matchMedia(query).matches);

  useLayoutEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMobile(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);

  return mobile;
};
